import { Component, computed, inject, input, output } from '@angular/core';
import { LucideBellRing, LucideDynamicIcon, LucideX } from '@lucide/angular';
import { ButtonComponent } from '../../../atoms/button/button.component';
import { TextDirective } from '../../../typography/text.directive';
import { NotificationComponent } from '../notification.component';
import { NotificationLayoutStackedAction } from './notification-layout-stacked.models';
import { JoiiIcon } from '../../../icons/lucide/icon';

@Component({
  selector: 'joii-notification-stacked',
  template: `
    <section id="notification-content">
      @if (icon()) {
        <span notification-icon>
          <svg [lucideIcon]="icon()" [size]="20" />
        </span>
      }
      <div id="title-body">
        <span joii-text color="tint1" [size]="4" weight="semibold">{{ title() }}</span>
        <span notification-body joii-text color="tint1" [size]="4">{{ body() }}</span>
      </div>
      @if (showCloseButton() && closeIcon()) {
        <button
          joii-button
          type="button"
          id="close-button"
          [iconOnly]="true"
          size="sm"
          variant="secondary"
          [icon]="closeIcon()"
          aria-label="Close notification"
          (click)="closeClick.emit(); $event.preventDefault(); $event.stopPropagation()"
        ></button>
      }
    </section>
    @if (actions().length > 0) {
      <section id="notification-actions">
        @for (action of actions(); track action.label) {
          <button
            joii-button
            [variant]="action.variant"
            [leadingIcon]="action.prefixIcon"
            [trailingIcon]="action.suffixIcon"
            (click)="onActionClick.emit(action); $event.preventDefault(); $event.stopPropagation()"
          >
            {{ action.label }}
          </button>
        }
      </section>
    }
  `,
  styleUrl: './notification-layout-stacked.component.css',
  imports: [LucideDynamicIcon, TextDirective, ButtonComponent],
  host: {
    '[attr.data-type]': 'type()',
    '(click)': 'onClick.emit();',
  },
})
export class NotificationLayoutStackedComponent {
  Notification = inject(NotificationComponent, { optional: true });
  type = computed(() => this.Notification?.type() ?? 'info');
  title = input.required<string>();
  body = input.required<string>();
  actions = input<NotificationLayoutStackedAction[]>([]);
  icon = input<JoiiIcon>(LucideBellRing);
  closeIcon = input<JoiiIcon>(LucideX);
  showCloseButton = input(true);
  closeClick = output<void>();
  onClick = output<void>();
  onActionClick = output<NotificationLayoutStackedAction>();
}
